import Vue from 'vue'
import CartButton from './components/pc/common/CartButton'
import HeaderMenu from './components/pc/common/HeaderMenu'
import UserStatus from './components/pc/common/UserStatus'
import CustomerStore from './stores/CustomerStore'

Vue.config.productionTip = false
CustomerStore.dispatch('loadCustomer');

/* eslint-disable no-new */
new Vue({
  el: '#header-menu-pc',
  render: h => h(HeaderMenu)
})

new Vue({
  el: '#cart-button-pc',
  render: h => h(CartButton)
})

new Vue({
  el: '#user-status-pc',
  render: h => h(UserStatus)
})



// WEBPACK FOOTER //
// ./src/header-parts-pc.js